<template>
	<div>
		<div class="generalTableClass myContainer">
			<div v-if="loading" class="spinner-wrapper">
				<b-spinner variant="primary"></b-spinner>
			</div>
			<b-row cols="xxl">
				<b-col cols="5">
					<table class="table b-table table-striped" size="xs" id="tblData"
					>
						<template>
							<tr>
								<th colspan="4">Nimdir</th>
							</tr>
							<tr>
								<th>1</th>
								<th>2</th>
								<th>3</th>
								<th>4</th>
							</tr>
						</template>
					</table>
				</b-col>
				<b-col cols="7" >
					<table  style="margin-left: -6.5%" class="table b-table table-striped" size="xs" id="tblData">
						<template v-for="c in car">
							<tr>
								<th colspan="2">{{ c.name }}</th>
							</tr>
							<tr>
								<th>{{ c.age }}</th>
								<th>2</th>
							</tr>
						</template>
					</table>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		selectDeps: {
			type: Array,
			default: () => {
				[];
			}
		}
	},
	data() {
		return {
			loading: false,
			depsName: [],
			car:[
				{name:'Tesla',age:'raqmlari'},
				{name:'Tesla',age:'raqmlari'},
				// {name:'Tesla',age:'raqmlari'},
				// {name:'Tesla',age:'raqmlari'},
				// {name:'Tesla',age:'raqmlari'},
				// {name:'Tesla',age:'raqmlari'},
				// {name:'Tesla',age:'raqmlari'},
				// {name:'Tesla',age:'raqmlari'},

			]
		}
	},
	methods: {

	}
}
</script>
